<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="mt-4 px-4">
    <div class="recharge-table-container">
      <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative mb-0">
        <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
          <label class="btn-import-file">
            <span class="material-symbols-outlined">upload_file</span>
            <span>Choisir un fichier</span>
            <input type="file" hidden (change)="fileChange($event)" id="fichier" accept=".xlsx,.xls,.csv" />
          </label>

          <button 
            class="btn-action btn-success" 
            (click)="import()" 
            [disabled]="!files || files.length === 0 || upload">
            <span class="material-symbols-outlined">cloud_upload</span>
            <span>{{ upload ? 'Import...' : 'Importer' }}</span>
          </button>

          <select class="select-recharge" [(ngModel)]="amount">
            <option [value]="null" disabled>Recharge...</option>
            <option *ngFor="let d of detail" [value]="d.id">
              {{ d.operateur }} - {{ d.montant }} € ({{ d.total }} codes)
            </option>
          </select>

          <button class="btn-action btn-primary" (click)="export()">
            <span class="material-symbols-outlined">download</span>
            <span>Exporter</span>
          </button>
        </div>
      </div>

      <div class="px-6 py-3 border-b border-gray-200">
        <div class="flex flex-wrap items-center gap-3">
          <small *ngIf="!upload && nbImporter > 0" class="success-message">
            <span class="material-symbols-outlined">check_circle</span>
            {{ nbImporter }} codes importés avec succès
          </small>

          <div *ngIf="upload" class="upload-indicator">
            <img src="assets/img/administration/downloading.gif" style="width: 30px;" />
            <span>Fichier en cours de téléchargement...</span>
          </div>
        </div>

        <div *ngIf="amount" class="flex flex-wrap items-end gap-3 mt-4">
          <div class="input-group">
            <label class="input-label">Quota pour le prochain code (en jours)</label>
            <input 
              type="number" 
              class="input-field" 
              [(ngModel)]="quotaProchainCode" 
              min="0" 
              placeholder="Ex: 30 jours" />
          </div>
          <button 
            class="btn-action btn-warning" 
            (click)="recharger()" 
            [disabled]="!quotaProchainCode || quotaProchainCode < 0">
            <span class="material-symbols-outlined">bolt</span>
            <span>Recharger les ports sélectionnés</span>
          </button>
        </div>
      </div>

      <div *ngIf="slots && slots.length > 0" class="archive-toggle-bar px-6 py-3 mb-0">
        <div class="archive-toggle-card">
          <span class="material-symbols-outlined">flash_on</span>
          <div class="archive-toggle-content">
            <div class="archive-toggle-title">Recharges actives</div>
            <div class="archive-toggle-count">{{ nbActive() }}</div>
          </div>
        </div>

        <div class="archive-toggle-card">
          <span class="material-symbols-outlined">schedule</span>
          <div class="archive-toggle-content">
            <div class="archive-toggle-title">Codes en attente</div>
            <div class="archive-toggle-count">{{ getNbCodesEnAttente() }}</div>
          </div>
        </div>
      </div>
    </div>
</div>
